import React from "react";
import { KgReportIcon } from "../../atoms/KgReportIcon";
import { useKgCanvasNavigation } from "../../kg/canvas/KgCanvasNavigationContext";
import {
  BodyCell,
  CountBadge,
  DateColumn,
  EmptyHint,
  HeaderCell,
  IconSlot,
  LinkedTitle,
  SectionHeader,
  SectionTitle,
  TabRoot,
  TableColumns,
  TableFrame,
  TitleColumn,
} from "./KgInspectorReportsTab.styles";
import type { KgInspectorReportsTabProps } from "./KgInspectorReportsTab.types";

const DEFAULT_COLUMNS = {
  primary: "TITLE",
  secondary: "CONNECTED ON",
} as const;

const DEFAULT_EMPTY_HINT = "No reports linked yet.";

export const KgInspectorReportsTab: React.FC<KgInspectorReportsTabProps> = ({
  reports,
  columnLabels = DEFAULT_COLUMNS,
  emptyHint = DEFAULT_EMPTY_HINT,
}) => {
  const { focusNode } = useKgCanvasNavigation();
  return (
  <TabRoot>
    <SectionHeader>
      <IconSlot>
        <KgReportIcon />
      </IconSlot>
      <SectionTitle>Reports</SectionTitle>
      {reports.length > 0 && <CountBadge>{reports.length}</CountBadge>}
    </SectionHeader>

    {reports.length === 0 ? (
      <EmptyHint>{emptyHint}</EmptyHint>
    ) : (
      <TableFrame>
        <TableColumns>
          <TitleColumn>
            <HeaderCell>{columnLabels.primary}</HeaderCell>
            {reports.map((row, index) => (
              <BodyCell key={row.title} $isLast={index === reports.length - 1}>
                {row.isLinked && row.canvasNodeId ? (
                  <LinkedTitle
                    as="button"
                    type="button"
                    onClick={() => focusNode(row.canvasNodeId!)}
                  >
                    {row.title}
                  </LinkedTitle>
                ) : row.isLinked ? (
                  <LinkedTitle>{row.title}</LinkedTitle>
                ) : (
                  row.title
                )}
              </BodyCell>
            ))}
          </TitleColumn>
          <DateColumn>
            <HeaderCell>{columnLabels.secondary}</HeaderCell>
            {reports.map((row, index) => (
              <BodyCell key={row.title} $isLast={index === reports.length - 1}>
                {row.secondary}
              </BodyCell>
            ))}
          </DateColumn>
        </TableColumns>
      </TableFrame>
    )}
  </TabRoot>
  );
};

export default KgInspectorReportsTab;
